<template>
 <div class="body-box">
    <el-row class="plan"></el-row>

   <el-row>
     <el-col :sapn="24">
       <el-calendar v-model="value" @click="lookTime">
         <template
           slot="dateCell"
           slot-scope="{date, data}">
           <p :class="data.isSelected ? 'is-selected' : ''">
             {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
           </p>
         </template>
       </el-calendar>
     </el-col>
   </el-row>
 </div>
</template>

<script>
export default {
  data () {
    return {
      value: Date.parse(new Date()),
    }
  },


  created() {

  },

  methods:{
    changTime(val) {

    },

    lookTime(e) {

    }
  }
}
</script>

<style lang="less" scoped>
.is-selected {
  color: #1989FA;
}
</style>
